import React from 'react';
import { Link } from 'react-router-dom';
export function ProblemSection() {
  return <section className="w-full bg-[#f8f8f8] py-16 md:py-24 pt-[56px] pb-[56px]" data-id="element-268">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-269">
        <div className="max-w-3xl mx-auto text-center" data-id="element-270">
          <h2 className="text-2xl md:text-3xl font-bold text-[#111111] mb-6" data-id="element-271">
            You shouldn't have to be your family's unpaid IT department
          </h2>
          <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-6" data-id="element-272">
            Every week it's the same calls. A suspicious email, a locked
            account, a password that "stopped working." You love your family,
            but you're tired of being the only one who can help. Caveo gives
            everyone the knowledge to handle it themselves.
          </p>

          <p className="text-base text-gray-500 mb-8" data-id="element-273">
            No downloads. No tech degree required. Just plain-English guidance
            that actually sticks.
          </p>
          <Link to="/intro-assessment" className="bg-[#631bb7] text-white px-8 py-4 rounded-lg font-bold inline-flex items-center justify-center no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-274">
            Take the Free Assessment
          </Link>
        </div>
      </div>
    </section>;
}